import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { ErrorsFlowTypes } from '_core/types/Responses';
import { updateMemberSensitiveDataApi as API } from '../Apis';

export const UpdateMemberSensitiveDataDocs: IDocs = {
  title: 'UpdateMemberSensitiveData',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.updateMemberSensitiveData',
};

const prepareCall = (stateRequestParameters: any) => {
  let documentList = {};
  if (
    stateRequestParameters?.document &&
    stateRequestParameters?.document?.value
  ) {
    documentList = {
      documentList: [
        {
          type: stateRequestParameters?.document?.type,
          number: stateRequestParameters?.document?.value,
        },
      ],
    };
  }

  return API.call.put({
    ...documentList,
    firstName: stateRequestParameters?.firstName,
    lastName: stateRequestParameters?.lastName,
    birthDate: stateRequestParameters?.birthDate,
    contactType: stateRequestParameters?.contactType,
    attachmentList: stateRequestParameters.attachmentList,
    minorLegalGuardian: stateRequestParameters?.minorLegalGuardian,
  });
};

const handleErrorFlowFinalResponseFunction = (infos: ErrorsFlowTypes) => {
  const smilesCheckAccount = !infos?.errorService;
  const smilesErrorService = infos?.errorService || !smilesCheckAccount;

  return { smilesCheckAccount, smilesErrorService };
};

export const UpdateMemberSensitiveDataMachine = GenericMachine(
  prepareCall,
  {
    docs: UpdateMemberSensitiveDataDocs,
    definitions: API.definitions,
  },
  {
    handleErrorFlowFinalResponseFunction,
  },
);
